<script>
export default {
  page: {
    title: 'Insurance',
    meta: [{ name: 'description', content: 'The Insurance page.' }],
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer" fluid>
    <div :class="$style.paper">
      <img
        :class="$style.image"
        :src="require('@assets/images/safehaven/Insurance.svg')"
      />

      <h4 class="mt-3 font-weight-bold">Insurance</h4>

      <p :class="$style.description">
        Easily access your insurance information, claims, and coverage details
        in one centralized location. Connecting your insurance to HealthBook+
        will empower you to make informed decisions about your healthcare by
        providing comprehensive and up-to-date information on your insurance
        benefits and medical history.

        <br />
        <br />

        <span :class="$style.coming">Coming Soon</span>
      </p>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.paper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 485px;
  padding: 30px 20px;
  margin: auto;
  margin-top: 64px;
  background-color: white;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.image {
  width: 180px;
}

.description {
  font-size: 14px;
}

.coming {
  font-weight: bold;
  color: #84b25a;
}
</style>
